import { Vue, Component } from 'vue-property-decorator';

@Component
export default class TutorialMixin extends Vue {
  get introStepsDefault() {
    return {}
  }

  get quickStartSection() {
    return '';
  }

  get isCurrentTutorial() {
    return this.$store.state.tutorial.quickStartSection === this.quickStartSection;
  }

  get introSteps(): any {
    return this.isCurrentTutorial
      ? this.introStepsDefault
      : {};
  }

  getIntroParams(step: number) {
    return this.introSteps[step] 
      ? {
        'data-step': step,
        'data-intro': this.introSteps[step]
      } 
      : {};
  }
}
